import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { hideModal } from '../../services/modal/actions';
import { deleteConnection, deleteAccount } from '../../services/account/alo/actions';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import ButtonComponent from '../button/ButtonComponent';
import { LoadingComponent } from '../loading/LoadingComponent';

import './AloDeleteAccountModal.scss';

class AloDeleteAccountModal extends React.Component {
    componentDidMount() {
        if (!this.props.connection && !this.props.account) {
            this.props.hideModal();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.deletingAccountConnection && !this.props.deletingAccountConnection) {
            this.props.hideModal();
        }
    }

    submit = () => {
        const { connection, deleteConnection, account, deleteAccount } = this.props;

        if (connection) {
            deleteConnection(connection.id);
        }
        if (account) {
            deleteAccount(account.id);
        }
    };

    render() {
        const { i18n, hideModal, deletingAccountConnection, connection, account } = this.props;

        return (
            <div className="alo-delete-account-modal">
                <div className="header">
                    <p>{i18n.HEADER}</p>
                </div>
                <div className="content">
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18n.TEXT1,
                            connection ? connection.name : account.name
                        )}
                    </p>
                    <p>{i18n.TEXT2}</p>
                    <p>{i18n.TEXT3}</p>
                </div>
                <div className={`buttons ${deletingAccountConnection ? 'loading' : ''}`}>
                    {deletingAccountConnection ? (
                        <LoadingComponent />
                    ) : (
                        <React.Fragment>
                            <ButtonComponent
                                text={i18n.CLOSE_BUTTON}
                                color="main"
                                onClick={hideModal}
                            />
                            <ButtonComponent
                                text={i18n.ACCEPT_BUTTON}
                                color="second"
                                onClick={this.submit}
                            />
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

AloDeleteAccountModal.propTypes = {
    connection: PropTypes.object,
    account: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.ALO.MODAL.DELETE_ACCOUNT,
        deletingAccountConnection: state.account.accountLinkedOffer.deletingAccountConnection
    };
};

const mapDispatchToProps = {
    hideModal,
    deleteConnection,
    deleteAccount
};

export default connect(mapStateToProps, mapDispatchToProps)(AloDeleteAccountModal);



// WEBPACK FOOTER //
// ./src/components/alo/AloDeleteAccountModal.js